import { createFileRoute } from "@tanstack/react-router";
import AnthemBcbsOhioInsurance, {
  config,
} from "@/pages/AnthemBcbsOhioInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/anthem-bcbs-ohio-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anthem BCBS Ohio TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anthem BCBS Ohio coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Anthem BCBS Ohio TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anthem BCBS Ohio coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/anthem-bcbs-ohio-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anthem-bcbs-ohio-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnthemBcbsOhioInsurance />;
}
